import { Button, Checkbox, Col, ConfigProvider, Radio, RadioChangeEvent, Row, TimePicker } from 'antd';
import Select from 'react-select';
import { PrinterFilled } from '@ant-design/icons';
import './style.css';
import { useEffect, useState } from 'react';
import { errorNotify } from '../../../services/toast.notification';
import { getBaseData, getLabReport } from '../../../api/api';
import { DatePicker as DatePickerJalali, JalaliLocaleListener, useJalaliLocaleListener } from "antd-jalali";
import fa_IR from "antd/lib/locale/fa_IR";
import Spinner from '../../../components/_common/Spinner';
import dayjs, { Dayjs } from 'dayjs';
import DownloadPdfFile from '../../../components/_common/DownloadZipFile/PdfFile';
import toast from 'react-hot-toast';

export enum BaseDataType {
    Test = 0,
    Insurance = 1,
    Contractor = 2,
    SuppInsurance = 3,
    Doctor = 4,
    Specialization = 5,
    DreamLabTest = 6,
    VirtualLab = 7,
    WorkArea = 8,
    Users = 9,
    Department = 10,
    Tube = 11,
    GroupTest = 12,
    TestForAdmit = 13,
    POS = 14,
    FamilyIns = 15,
    SajaSamples = 16,
    Machines = 17,
    OutSiteSampler = 18,
}
export interface InputProps {
    url: any,
    service_url: any
}

const PerformanceReport = ({ url, service_url }: InputProps) => {

    const [data, setData] = useState('');
    const [usersList, setUsersList] = useState<any[]>([]);
    const [virtualLabList, setVirtualLabList] = useState<any[]>([]);
    const [departmentList, setDepartmentList] = useState<any[]>([]);
    const [virtualMotherTubeList, setVirtualMotherTubeList] = useState<any[]>([]);
    const [groupList, setGroupList] = useState<any[]>([]);
    const [testList, setTestList] = useState<any[]>([]);

    const [report, setReport] = useState('0');
    const [tubeRadioVal, setTubeRadioVal] = useState(true);
    const [tubeId, setTubeId] = useState(0);
    const [imageSource, setImageSource] = useState("");
    const [isImageSource, setIsImageSource] = useState(false);

    const [fdate, setFirstDate] = useState<any>(undefined);
    const [ldate, setLastDate] = useState<any>(undefined);
    const [ftime, setFirstTime] = useState<any>(undefined);
    const [ltime, setLastTime] = useState<any>(undefined);

    const [isLoading, setIsLoading] = useState(true);

    const receptionList = [
        { label: 'حضوری', value: '0' },
        { label: 'ارسالی', value: '1' },

    ];

    const ReportList = [
        { label: 'حضوری', value: '0' },
        { label: 'نمونه', value: '1' },
        { label: 'جواب', value: '2' },

    ];

    const ReportPeriodList = [
        { label: 'هر یک ساعت', value: '1' },
        { label: 'هر نیم ساعت', value: '2' },
        { label: 'هر ربع ساعت', value: '3' },

    ];

    const [values, setValues] = useState({
        reception: receptionList[0],
        firstDate: "",
        lastDate: "",
        fromTime: "",
        toTime: "",
        userId: { label: "همه", value: "0" },
        virtualLabId: { label: "همه", value: "0" },
        report: ReportList[0],
        isReportDetails: false,
        reportPeriod: ReportPeriodList[0],
        department:  { label: "همه", value: "0" },
        tubeId:  { label: "همه", value: "0" },
        groupId: { label: "همه", value: "0" },
        isEmergency: false,
        test: { label: "همه", value: "0" },
        threeSD: false
    });
   
    const onChangeReceptionList = (event: any) => {
        const { label, value } = event;

        setValues((val: any) => ({
            ...val,
            reception: { label: label, value: value }
        }))

    }

    const onChangeReportList = (event: any) => {
        const { label, value } = event;
        if (value !== "0") {
            _getDepartmentList(url, BaseDataType.Department, 0, 0, false);
            _getTubeList(url, BaseDataType.Tube, 0, 0, false, true);
        }
        setValues((val: any) => ({
            ...val,
            report: { label: label, value: value }
        }))
    }

    const onChangeDepartmentList = (event: any) => {
        const { label, value } = event;
       
        setValues((val: any) => ({
            ...val,
            department: { label: label, value: value }
        }))
    }

    const onChangeTestList = (event: any) => {
        const { label, value } = event;
      
        setValues((val: any) => ({
            ...val,
            test: { label: label, value: value }
        }))
    }

    const onChangeReportDetailsCheckbox = (event: any) => {
       
        setValues((val: any) => ({
            ...val,
            isReportDetails: event.target.checked
        }))
    }

    const onChangeIsEmergency = (event: any) => {

        setValues((val: any) => ({
            ...val,
            isEmergency: event.target.checked
        }))
    }

    const onChangeThreeSD = (event: any) => {

        setValues((val: any) => ({
            ...val,
            threeSD: event.target.checked
        }))
    }


    const onChangeTubeRadio = (e: RadioChangeEvent) => {
        setTubeRadioVal(e.target.value);
        _getTubeList(url, BaseDataType.Tube, 0, 0, false, e.target.value);
    }

    const onChangeTubeList = (event: any) => {
        const { label, value } = event;
        setValues((val: any) => ({
            ...val,
            tubeId: { label: label, value: value }
        }))
        _getGroupList(url, BaseDataType.GroupTest, value, 0, false);
    }

    const onChangeGroupList = (event: any) => {
        const { label, value } = event;
        setValues((val: any) => ({
            ...val,
            groupId: { label: label, value: value }
        }))
        _getTestList(url, BaseDataType.Test, tubeId, value, false);
    }

    const onChangeUserList = (event: any) => {
        const { label, value } = event;
        
        setValues((val: any) => ({
            ...val,
            userId: { label: label, value: value }
        }))
    }

    const onChangeReportPeriodList = (event: any) => {
        const { label, value } = event;
    
        setValues((val: any) => ({
            ...val,
            reportPeriod: { label: label, value: value }
        }))
    }

    const onChangeVirtualLabList = (event: any) => {
        const { label, value } = event;
       
        setValues((val: any) => ({
            ...val,
            virtualLabId: { label: label, value: value }
        }))
    }


    const _getUsersList = (url: string, baseType: number, tubeId: number, groupTestId: number, isForAdmit: boolean) => {
        setIsLoading(true);
        getBaseData(url, baseType, tubeId, groupTestId, isForAdmit)
            .then((result: any) => {
                let jsonResult = JSON.parse(result.data.json);

                const uList: any = [];
                jsonResult.listOfUser.map((item: any) => {
                    uList.push({ label: item.Str_UserFullName, value: item.PRK_UsersID });
                });
                setUsersList(uList);
                // if (uList.length > 0) {
                //     setValues((val: any) => ({
                //         ...val,
                //         userId: { label: uList[0].Str_UserFullName, value: uList[0].PRK_UsersID }
                //     }))
                // }

                _getVirtualLab(url, BaseDataType.VirtualLab, 0, 0, false);


                setIsLoading(false);
            })
            .catch((error) => {
                console.log(error);
                errorNotify(error.response.data.errorMessage, undefined, 5000)
            })
    }

    const _getDepartmentList = (url: string, baseType: number, tubeId: number, groupTestId: number, isForAdmit: boolean) => {
        setIsLoading(true);
        getBaseData(url, baseType, tubeId, groupTestId, isForAdmit)
            .then((result: any) => {
                let jsonResult = JSON.parse(result.data.json);

                const dList: any = [];
                jsonResult.listOfDepartment.map((item: any) => {
                    dList.push({ label: item.Str_DepartmentName, value: item.Prk_DepartmentInfo });
                });
                setDepartmentList(dList);
                // if (dList.length > 0) {
                //     setValues((val: any) => ({
                //         ...val,
                //         department: { label: dList[0].Str_DepartmentName, value: dList[0].Prk_DepartmentInfo }
                //     }))
                // }


                setIsLoading(false);
            })
            .catch((error) => {
                console.log(error);
                errorNotify(error.response.data.errorMessage, undefined, 5000)
            })
    }

    const _getTubeList = (url: string, baseType: number, tubeId: number, groupTestId: number, isForAdmit: boolean, tubeVal: boolean) => {
        setIsLoading(true);
        getBaseData(url, baseType, tubeId, groupTestId, isForAdmit)
            .then((result: any) => {
                let jsonResult = JSON.parse(result.data.json);

                const tList: any = [];
                jsonResult.Tube.map((item: any) => {
                    if (item.Bit_VirtualMotherTube == tubeVal)
                        tList.push({ label: item.Str_TubeName, value: item.Prk_TubeID });
                });
                setVirtualMotherTubeList(tList);
                // if (tList.length > 0) {
                //     setValues((val: any) => ({
                //         ...val,
                //         tubeId: { label: tList[0].Str_TubeName, value: tList[0].Prk_TubeID }
                //     }))
                // }

                setIsLoading(false);
            })
            .catch((error) => {
                console.log(error);
                errorNotify(error.response.data.errorMessage, undefined, 5000)
            })
    }


    const _getVirtualLab = (url: string, baseType: number, tubeId: number, groupTestId: number, isForAdmit: boolean) => {
        setIsLoading(true);
        getBaseData(url, baseType, tubeId, groupTestId, isForAdmit)
            .then((result: any) => {
                let jsonResult = JSON.parse(result.data.json);

                const vList: any = [];
                jsonResult.VirtualLab.map((item: any) => {
                    vList.push({ label: item.Str_Name, value: item.Prk_VirtualLab_AutoID });
                });
                setVirtualLabList(vList);
                // if (vList.length > 0) {
                //     setValues((val: any) => ({
                //         ...val,
                //         virtualLabId: { label: vList[0].Str_Name, value: vList[0].Prk_VirtualLab_AutoID }
                //     }))
                // }
                setIsLoading(false);
            })
            .catch((error) => {
                console.log(error);
                setIsLoading(false);
                errorNotify(error.response.data.errorMessage, undefined, 5000)
            })
    }

    const _getGroupList = (url: string, baseType: number, tubeId: number, groupTestId: number, isForAdmit: boolean) => {
        setIsLoading(true);
        getBaseData(url, baseType, tubeId, groupTestId, isForAdmit)
            .then((result: any) => {
                let jsonResult = JSON.parse(result.data.json);

                const gList: any = [];
                jsonResult.GroupInfo.map((item: any) => {
                    gList.push({ label: item.Str_TestNameGroup, value: item.Prk_TestGroupID });
                });
                setGroupList(gList);
                // if (gList.length > 0) {
                //     setValues((val: any) => ({
                //         ...val,
                //         groupId: { label: gList[0].Str_TestNameGroup, value: gList[0].Prk_TestGroupID }
                //     }))
                // }
                setIsLoading(false);
            })
            .catch((error) => {
                console.log(error);
                setIsLoading(false);
                errorNotify(error.response.data.errorMessage, undefined, 5000)
            })
    }

    const _getTestList = (url: string, baseType: number, tubeId: number, groupTestId: number, isForAdmit: boolean) => {
        setIsLoading(true);
        getBaseData(url, baseType, tubeId, groupTestId, isForAdmit)
            .then((result: any) => {
                let jsonResult = JSON.parse(result.data.json);

                const tList: any = [];
                jsonResult.Tests.map((item: any) => {
                    tList.push({ label: item.Str_SpecialName, value: item.Prk_TestInternalNum });
                });
                setTestList(tList);
                // if (tList.length > 0) {
                //     setValues((val: any) => ({
                //         ...val,
                //         test: { label: tList[0].Str_SpecialName, value: tList[0].Prk_TestInternalNum }
                //     }))
                // }
                setIsLoading(false);
            })
            .catch((error) => {
                console.log(error);
                setIsLoading(false);
                errorNotify(error.response.data.errorMessage, undefined, 5000)
            })
    }

    let toastId: any;

    const _getLabReport = () => {
        setIsLoading(true);

        getLabReport(service_url, values)
            .then((result: any) => {

                if (result.data !== "") {
                    toastId = toast.loading('...درحال آماده سازی فایل گزارش');

                    let pdfArray: any[] = [];

                    pdfArray.push(`${result.data[0].FileContent}`);
                    DownloadPdfFile(pdfArray, "گزارش");
                    setImageSource(result.data[0].FileContent);
                    setIsImageSource(true);

                    toast.dismiss(toastId);
                    setData(result.data[0].FileContent);

                }
                else {
                    errorNotify("داده ای برای نمایش وجود ندارد!");
                }
                setIsLoading(false);
            })
            .catch((error) => {
                console.log(error);
                toast.dismiss(toastId);
                setIsLoading(false);
                errorNotify(error.response.data.errorMessage, undefined, 5000)
            })
    }

    const onChangeDatePicker = (dates: any, dateStrings: any, info: any) => {

        if (!dateStrings) return;
        if (dateStrings.length < 2) return;
        if (dateStrings[0] === "") return;
        if (dateStrings[1] === "") return;

        setFirstDate(dates[0])
        setLastDate(dates[1])


        setValues((val: any) => ({
            ...val,
            firstDate: dateStrings[0]
        }))

        setValues((val: any) => ({
            ...val,
            lastDate: dateStrings[1]
        }))
        
    }

    const onChangeFromTime = (time: Dayjs, timeString: string) => {
        console.log(timeString);
        setFirstTime(time);
        setValues((val: any) => ({
            ...val,
            fromTime: timeString
        }))
    };

    const onChangeToTime = (time: Dayjs, timeString: string) => {
        console.log(timeString);
        setLastTime(time);
        setValues((val: any) => ({
            ...val,
            toTime: timeString
        }))
    };

    const downloadReport = () => {
        _getLabReport();
    }



    useEffect(() => {
        const valueFrom = dayjs().hour(6).minute(0).second(0);
        setFirstTime(valueFrom);
        const valueTo = dayjs().hour(23).minute(59).second(0);
        setLastTime(valueTo);

        debugger;
        _getUsersList(url, BaseDataType.Users, 0, 0, false);
        setIsLoading(false);
    }, [])

    return (
        <>
            {
                isLoading === false && (
                    <>
                        <div style={{ paddingRight: '10px' }} >
                            <Row className='header-border'>
                            <Col lg={12} md={12} sm={12} xs={12} style={{ display: 'flex', float: 'right', padding: '10px' }}>
                                    <span style={{ width: '50px', paddingTop: '5px' }}>پذیرش: </span>
                                    <span style={{ width: '150px' }}>
                                        <div className="App">
                                            <Select value={{ label: values.reception.label, value: values.reception.value }}
                                                options={receptionList}
                                                onChange={(e) => onChangeReceptionList(e)} />
                                        </div>
                                    </span>
                                </Col>
                                <Col lg={12} md={12} sm={12} xs={12} style={{ float: 'left', padding: '10px 0 0 20px' }}>
                                    <Button type="primary" onClick={downloadReport} icon={<PrinterFilled />} >نمایش گزارش</Button>
                                </Col>
                            </Row>
                            <Row style={{ marginTop: '15px' }}>
                                <Col lg={6} md={6} sm={24} xs={24} className="calender">
                                    <span>تاریخ: </span>
                                    <span style={{ width: '300px', display: 'inline-block' }}>
                                        <ConfigProvider locale={fa_IR} direction="rtl">
                                            <JalaliLocaleListener />
                                            <DatePickerJalali.RangePicker value={[fdate, ldate]} format={"YYYY/MM/DD"} onCalendarChange={(dates: any, dateStrings: any, info: any) => onChangeDatePicker(dates, dateStrings, info)} />
                                        </ConfigProvider>
                                    </span>
                                </Col>
                                <Col lg={8} md={8} sm={24} xs={24} className="row time-display" style={{  justifyContent: 'space-between' }} >
                                    <span style={{ padding: '0' }}>زمان: </span>
                                    <div style={{ width: '300px', display: 'block ruby', padding: '0' }}>
                                        <span>
                                            <TimePicker style={{ width: '120px' }} value={ftime} format={"HH:mm:ss"} onChange={(time: any, timeString: string) => onChangeFromTime(time, timeString)} />
                                        </span>
                                        <span style={{ padding: '10px' }}>تا</span>
                                        <span >
                                            <TimePicker style={{ width: '120px' }} value={ltime} format={"HH:mm:ss"} onChange={(time: any, timeString: string) => onChangeToTime(time, timeString)} />
                                        </span>
                                    </div>
                                </Col>
                                <Col lg={4} md={4} sm={24} xs={24} style={{ float: 'right' }}>
                                    <span style={{ width: '50px' }}>کاربر: </span>
                                    <span style={{ width: '150px', display: 'inline-block' }}>
                                        <div className="App">
                                            <Select value={{ label: values.userId.label, value: values.userId.value }}
                                                options={usersList}
                                                onChange={(e) => onChangeUserList(e)} />
                                        </div>
                                    </span>
                                </Col>
                                <Col lg={6} md={6} sm={24} xs={24} style={{ float: 'right' }}>
                                    <span>آز مجازی: </span>
                                    <span style={{ width: '200px', display: 'inline-block' }}>
                                        <div className="App">
                                            <Select value={{ label: values.virtualLabId.label, value: values.virtualLabId.value }}
                                                options={virtualLabList}
                                                onChange={(e) => onChangeVirtualLabList(e)} />
                                        </div>
                                    </span>
                                </Col>
                            </Row>

                            <div className='row' style={{ marginTop: '10px' }}>
                                <div className='col-md-4' style={{ display: 'inline-flex' }}>
                                    <span style={{ width: '50px', paddingTop: '5px' }}> گزارش: </span>
                                    <span style={{ width: '150px ' }}>
                                        <div className="App">
                                            <Select value={{ label: values.report.label, value: values.report.value }}
                                                options={ReportList}
                                                onChange={(e) => onChangeReportList(e)}
                                            />
                                        </div>
                                    </span>
                                </div>
                                {report === '0' && (<div className='col-md-8' style={{ display: 'inline-flex' }}>
                                    <span style={{ width: '150px', paddingTop: '5px' }}>
                                        <Checkbox
                                            name="isGroup"
                                            onChange={(e) => onChangeReportDetailsCheckbox(e)}
                                            value={values.isReportDetails}
                                            checked={values.isReportDetails}
                                        >
                                            {"با گزارش جزیی"}
                                        </Checkbox>
                                    </span>
                                    <span style={{ width: '150px' }}>
                                        <div className="App">
                                            <Select value={{ label: values.reportPeriod.label, value: values.reportPeriod.value }}
                                                options={ReportPeriodList} isDisabled={!values.isReportDetails}
                                                onChange={(e) => onChangeReportPeriodList(e)} />
                                        </div>
                                    </span>
                                </div>
                                )
                                }
                            </div>

                            {
                                values.report.value !== '0' && values.report.value !== '-1' && (
                                    <div className='row report-border'>
                                        <div className="col-md-2">
                                            <span>بخش:</span>
                                            <span style={{ width: '150px' }}>
                                                <div className="App">
                                                    <Select value={{ label: values.department.label, value: values.department.value }}
                                                        options={departmentList}
                                                        onChange={(e) => onChangeDepartmentList(e)} />
                                                </div>
                                            </span>
                                        </div>
                                        <div className="col-md-3">
                                            <span> <Radio.Group
                                                onChange={onChangeTubeRadio} value={tubeRadioVal}
                                            >
                                                <div>
                                                    <Radio value={true}>لوله اصلی</Radio>
                                                    <Radio value={false}>لوله تفکیکی</Radio>
                                                </div>

                                            </Radio.Group>
                                            </span>
                                            <span style={{ width: '150px' }}>
                                                <div className="App">
                                                    <Select value={{ label: values.tubeId.label, value: values.tubeId.value }}
                                                        options={virtualMotherTubeList}
                                                        onChange={(e) => onChangeTubeList(e)} />
                                                </div>
                                            </span>
                                        </div>
                                        <div className="col-md-2">
                                            <span>گروه:</span>
                                            <span style={{ width: '150px' }}>
                                                <div className="App">
                                                    <Select value={{ label: values.groupId.label, value: values.groupId.value }}
                                                        options={groupList}
                                                        onChange={(e) => onChangeGroupList(e)} />
                                                </div>
                                            </span>
                                        </div>
                                        <div className="col-md-3">
                                            <span>تست: </span>  <Checkbox
                                                name="isEmergency"
                                                onChange={(e) => onChangeIsEmergency(e)}
                                                value={values.isEmergency}
                                            >
                                                {" فقط اورژانسی "}
                                            </Checkbox>
                                            <span style={{ width: '150px' }}>
                                                <div className="App">
                                                    <Select value={{ label: values.test.label, value: values.test.value }}
                                                        options={testList}
                                                        onChange={(e) => onChangeTestList(e)} />
                                                </div>
                                            </span>
                                        </div>
                                        <div className="col-md-2" style={{ marginTop: '30px' }}>
                                            <Checkbox
                                                name="isGroup"
                                                onChange={(e) => onChangeThreeSD(e)}
                                                value={values.threeSD}
                                            >
                                                {"خارج از 3SD"}
                                            </Checkbox>
                                        </div>
                                    </div>
                                )}

                        </div>

                        <div style={{ marginTop: '40px', marginBottom: '20px' }}>
                            {isImageSource && (
                                <center><embed src={`data:application/pdf;base64,${imageSource}`} style={{ width: '90%', height: '500px' }} /></center>)}

                        </div>
                    </>
                )
            }
            {
                isLoading === true && (
                    <Spinner />
                )
            }
        </>
    )
}

export default PerformanceReport;

